export default __webpack_public_path__ + "static/media/bkg--agent.f73411a4.jpg";